import(/* webpackMode: "eager" */ "D:\\GIT Repos\\assistiv\\app\\page.tsx")